(function() {
    var Note = function($el) {
        this.$el = $el
        this.$deleteBtn = this.$el.find('.note-delete-btn')
        this.id = this.$el.data('id')

        this.bind()
    
        return this
    }

    Note.prototype.bind = function() {
        this.$deleteBtn.on('click', this.destroy.bind(this))
    }

    Note.prototype.unbind = function() {
        this.$deleteBtn.off()
    }

    Note.prototype.destroy = function() {
        this.$deleteBtn.button('loading');

        $.ajax(franchiseRoute('notes/' + this.id + '/destroy'), {
                type: 'DELETE'
            })
            .done(this.hide.bind(this))
            .fail(this.renderApiError.bind(this))
    }

    Note.prototype.hide = function() {
        this.$el.unbind()
        this.$el.fadeOut()
    }

    Note.prototype.renderApiError = function() {
        this.$deleteBtn.button('reset');
        alert('Error');
    }

    var NotesTab = function($el) {
        this.$el = $el
        this.$addNoteBtn = this.$el.find('.add-note-btn')
        this.$loader = this.$el.find('.loader')
        this.$listContainer = this.$el.find('.note-list-container')
        this.listTemplate = Handlebars.compile(this.$el.find('.note-list-template').html())
        this.$noteField = this.$el.find('textarea[name=note]')
        this.notableType = this.$el.data('notableType')
        this.notableId = this.$el.data('notableId')
        this.url = franchiseRoute('notes')

        this.bind()
        this.getNotes()
    
        return this
    }

    NotesTab.prototype.bind = function() {
        this.$addNoteBtn.on('click', this.addNote.bind(this))
    }

    NotesTab.prototype.addNote = function() {
        this.validate()

        if (! this.isValid()) {
            return
        }

        this.loaderShow()

        $.post(this.url, {
                note: this.$noteField.val(),
                notable_type: this.notableType,
                notable_id: this.notableId
            })
            .done(this.getNotes.bind(this))
            .done(this.resetForm.bind(this))
            .fail(this.renderApiError.bind(this))
            .always(this.loaderHide.bind(this))
    }

    NotesTab.prototype.getNotes = function() {
        this.loaderShow()

        $.get(this.url, {
                notable_type: this.notableType,
                notable_id: this.notableId
            })
            .done(this.renderList.bind(this))
            .fail(this.renderApiError.bind(this))
            .always(this.loaderHide.bind(this))
    }

    NotesTab.prototype.isValid = function() {
        return this.$noteField.val().length > 0
    }

    NotesTab.prototype.loaderHide = function() {
        this.$addNoteBtn.button('reset');
        this.$loader.hide()
    }

    NotesTab.prototype.loaderShow = function() {
        this.$addNoteBtn.button('loading');
        this.$loader.show()
        this.$listContainer.html('')
    }

    NotesTab.prototype.renderList = function(notes) {
        this.$listContainer.html(this.listTemplate(notes))

        this.$el.find('.note-item')
            .each(function() {
                new Note($(this))
            })
    }

    NotesTab.prototype.validate = function() {
        if (this.isValid()) {
            this.$noteField.removeClass('alert-danger');
        } else {
            this.$noteField.addClass('alert-danger');
        }
    }

    NotesTab.prototype.renderApiError = function() {
        alert('Error');
    }

    NotesTab.prototype.resetForm = function() {
        this.$noteField.val('')
    }
    
    $('.notes-tab').each(function() {
        new NotesTab($(this))
    })
})()
